//criteria context menu values list : claim statuses | products
const valuesList = {
  'claim-status': [],
  products: [
    { label: 'Medical', value: 'MM' },
    { label: 'Dental', value: 'DE' },
    { label: 'Vision', value: 'VI' },
    { label: 'Prescription', value: 'RX' },
    { label: 'Flex', value: 'FX' },
    { label: 'Disability', value: 'DI' },
  ],
};

//Criteria context menu items list
const criteriaMenuItems = [
  {
    label: 'Claim Number',
    value: 'claim-number',
    type: 'string',
    isMinimumSearchCriteria: true,
  },
  {
    label: 'Claim Status',
    value: 'claim-status',
    type: 'array',
    defaultValue: [],
    subType: 'string',
  },
  { label: 'Claim Date', value: 'claim-date', type: 'array', defaultValue: [] },
  {
    label: 'Products',
    value: 'products',
    type: 'array',
    defaultValue: [],
    subType: 'string',
  },
  {
    label: 'SCCF#',
    value: 'sccf',
    type: 'string',
    defaultValue: '',
    isMinimumSearchCriteria: true,
  },
  {
    label: 'Member/Dependent',
    value: 'member-information',
    type: 'array',
    subType: 'object',
    defaultValue: [
      {
        first_name: '',
        last_name: '',
        dob: '',
        member_id: '',
        patient_control_number: '',
      },
    ],
    isMinimumSearchCriteria: true,
  },
  {
    label: 'Providers',
    value: 'provider-information',
    type: 'array',
    defaultValue: [],
    isMinimumSearchCriteria: true,
  },
];

//default values for all criteria items
const criteriaDefaultValues = {
  'claim-status': [],
  products: [],
  sccf: '',
  'member-information': {
    first_name: null,
    last_name: null,
    dob: null,
    member_id: null,
    patient_control_number: null,
  },
  'provider-information': {
    type: { label: 'Doctor', value: 'doctor' },
    search_by: { label: "Doctor's Name, Tax ID", value: 'name-tax-id' },
    name: null,
    facility_name: null,
    npi: null,
    tax_id: null,
    specialty: null,
    city: null,
    state: null,
    zip_code: null,
    county: null,
  },
  'claim-date': {
    type: null,
    date_range: null,
    date_from: null,
    date_to: null,
  },
  //'claim-status' 'products', 'sccf', 'member-information', 'provider-information', 'claim-date'
};

//options for member types
const memberTypeOptions = [
  { label: 'Member', value: 'Member' },
  { label: 'Dependent', value: 'Dependent' },
  { label: 'Both', value: 'both' },
];

//options for provider type
const providerTypeOptions = [
  { label: 'Doctor', value: 'doctor' },
  { label: 'Facility', value: 'facility' },
];

//options for search by provider type
const searchByProviderOptions = {
  doctor: [
    { label: "Doctor's Name, Tax ID", value: 'name-tax-id' },
    { label: "Doctor's Name, NPI", value: 'name-npi' },
    { label: 'Doctor TAX ID', value: 'tax-id' },
    { label: 'Doctor Specialty', value: 'specialty' },
  ],
  facility: [
    { label: 'Facility Name, Tax ID', value: 'name-tax-id' },
    { label: 'Facility TAX ID', value: 'tax-id' },
    { label: 'Facility Specialty', value: 'specialty' },
  ],
};

const claimDateSearchByOptions = [
  { label: 'Processed Date', value: 'processed-date' },
  { label: 'Paid Date', value: 'paid-date' },
  { label: 'Service Date', value: 'service-date' },
  { label: 'Received Date', value: 'received-date' },
];

const claimDateDateRangeOptions = [
  { label: 'Last 1 week', value: 'last-1-week' },
  { label: 'Last 1 month', value: 'last-1-month' },
  { label: 'Last 3 months', value: 'last-3-months' },
  { label: 'Last 6 months', value: 'last-6-months' },
  { label: 'Last One year', value: 'last-one-year' },
  { label: 'Custom Date', value: 'custom-date' },
];

export {
  valuesList,
  criteriaMenuItems,
  memberTypeOptions,
  criteriaDefaultValues,
  providerTypeOptions,
  searchByProviderOptions,
  claimDateSearchByOptions,
  claimDateDateRangeOptions,
};
